var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("circle", {
    cx: 5.99,
    cy: 3.75,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.813,11.422A5.251,5.251,0,0,0,.74,13.5v2.25H2.99l.75,7.5h4.5l.319-3.2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.99,
    y1: 8.25,
    x2: 5.99,
    y2: 14.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.311,20.078a2,2,0,1,1,3.276-2.145.5.5,0,0,0,.819.171l1.562-1.561a1,1,0,0,0,0-1.414l-1.6-1.6a2,2,0,1,0-2.449-2.449l-1.6-1.6a1,1,0,0,0-1.415,0l-1.449,1.449a.5.5,0,0,0,.077.771,2.024,2.024,0,0,1,.312.255,2,2,0,1,1-3.083,2.517.5.5,0,0,0-.771-.078l-1.45,1.45a1,1,0,0,0,0,1.414l5.657,5.657a1,1,0,0,0,1.415,0l1.561-1.562a.5.5,0,0,0-.171-.819A1.97,1.97,0,0,1,17.311,20.078Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.129,1.405c.537,1.811,2.762,2.8,4.861,2.345"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.7f55a27f.svg";
export { ForwardRef as ReactComponent };